var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBin = function SvgBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.403,
    height: 23.071
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2a4d4f"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3953",
    d: "m2.231 4.765 1.692 17.206h11.488l1.758-17.206Zm16.042-.035-1.872 18.34H2.931L1.128 4.727a1.456 1.456 0 0 1 .328-2.875h3.425L6.353-.004h7.277l1.058 1.853h3.259a1.458 1.458 0 0 1 .328 2.878ZM6.282 1.852h7.144l-.432-.756H6.88Zm11.665 1.099H1.456a.358.358 0 1 0 0 .716h16.491a.358.358 0 0 0 0-.716Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3954",
    d: "M7.94 8.189a.55.55 0 0 1 1.1 0v10.587a.55.55 0 0 1-1.1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3955",
    d: "M5.519 8.189a.55.55 0 0 1 1.1 0v10.587a.55.55 0 0 1-1.1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3956",
    d: "M10.362 8.189a.55.55 0 0 1 1.1 0v10.587a.55.55 0 0 1-1.1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3957",
    d: "M12.783 8.189a.55.55 0 0 1 1.1 0v10.587a.55.55 0 0 1-1.1 0Z"
  }))));
};
export default SvgBin;